/* PoppyLoco theme JS */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.PoppyLoco && window.PoppyLoco.money_format) || '{{amount_with_comma_separator}} €';
    const v = (cents / 100);
    const withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const noDec = Math.round(v).toString();
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  };

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  $$('.reveal').forEach((el) => io.observe(el));

  /* ---------- Header shadow ---------- */
  const header = $('#Header');
  if (header) window.addEventListener('scroll', () => header.classList.toggle('is-scrolled', window.scrollY > 10), { passive: true });

  /* ---------- Modals ---------- */
  const openModal = (id) => { const m = document.getElementById(id); if (!m) return; m.classList.add('is-open'); document.body.classList.add('overflow-hidden'); };
  const closeModals = () => { $$('.modal.is-open').forEach((m) => m.classList.remove('is-open')); document.body.classList.remove('overflow-hidden'); };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-modal-open]'); if (o) { e.preventDefault(); openModal(o.dataset.modalOpen); return; }
    if (e.target.closest('[data-modal-close]')) closeModals();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeModals(); closeCart(); } });

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');
  const overlay = $('[data-cart-overlay]');
  const openCart = () => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); overlay.classList.add('is-open'); document.body.classList.add('overflow-hidden'); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); overlay.classList.remove('is-open'); document.body.classList.remove('overflow-hidden'); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); drawer.classList.contains('is-open') ? closeCart() : openCart(); }
    if (e.target.closest('[data-cart-overlay]')) closeCart();
  });

  async function refreshCart() {
    const res = await fetch(window.location.pathname + '?section_id=cart-drawer-items', { headers: { Accept: 'text/html' } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = doc.querySelector('[data-cart-items]');
    if (items && $('[data-cart-items]')) $('[data-cart-items]').innerHTML = items.innerHTML;
    const cart = await (await fetch(window.PoppyLoco.routes.cart_url + '.js')).json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    $$('[data-cart-total]').forEach((el) => (el.textContent = money(cart.total_price)));
    const foot = $('[data-cart-footer]'); if (foot) foot.hidden = cart.item_count === 0;
    const up = $('[data-cart-upsell]'); if (up) up.hidden = cart.item_count === 0;
    const th = window.PoppyLoco.free_shipping_threshold;
    if (th > 0) {
      const msg = $('[data-shipping-msg]'); const bar = $('[data-shipping-progress]');
      const rem = th - cart.total_price;
      if (msg) msg.innerHTML = rem > 0 ? window.PoppyLoco.strings.free_shipping_remaining.replace('%s', '<b>' + money(rem) + '</b>') : '🎉 ' + window.PoppyLoco.strings.free_shipping_unlocked;
      if (bar) bar.style.width = Math.min(100, (cart.total_price / th) * 100) + '%';
    }
    return cart;
  }

  async function addToCart(id, quantity, items) {
    const payload = items && items.length ? { items } : { items: [{ id, quantity }] };
    const res = await fetch(window.PoppyLoco.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || 'Erreur'); }
    await refreshCart();
    openCart();
  }

  async function changeLine(line, quantity) {
    await fetch(window.PoppyLoco.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    await refreshCart();
  }

  document.addEventListener('click', async (e) => {
    const item = e.target.closest('.cart-item'); if (!item) return;
    const line = Number(item.dataset.line);
    const input = $('[data-qty-input]', item);
    if (e.target.closest('[data-qty-plus]')) changeLine(line, Number(input.value) + 1);
    if (e.target.closest('[data-qty-minus]')) changeLine(line, Math.max(0, Number(input.value) - 1));
    if (e.target.closest('[data-remove]')) changeLine(line, 0);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-qty-input]')) { const item = e.target.closest('.cart-item'); changeLine(Number(item.dataset.line), Number(e.target.value)); }
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-upsell]'); if (!b) return;
    b.disabled = true; addToCart(Number(b.dataset.variantId), 1).finally(() => (b.disabled = false));
  });

  /* ---------- Product ---------- */
  const section = $('#ProductSection');
  if (section) {
    const variants = JSON.parse($('[data-variants]', section)?.textContent || '[]');
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const qtyInput = $('[data-quantity]', section);
    const atc = $('[data-atc]', section);
    const bundle = $('[data-bundle]', section);
    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];
    let qty = 1, pct = 0;

    const selectedOptions = () => $$('.variant', section).map((f) => $('input:checked', f)?.value);

    /* Bundle rows: one (colour, size) picker per hoodie when qty > 1 */
    const rowsWrap = bundle && $('[data-bundle-items]', bundle);
    const rowsHost = bundle && $('[data-bundle-rows]', bundle);
    const rowTpl = bundle && $('[data-bundle-row]', bundle);
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    const rowOptions = (row) => $$('select[data-row-option]', row).map((sel) => sel.value);
    const rowVariant = (row) => findVariant(rowOptions(row));
    function syncRowStatus(row) {
      const v = rowVariant(row); const st = $('[data-row-status]', row);
      st.textContent = !v ? window.PoppyLoco.strings.unavailable : (v.available ? '' : window.PoppyLoco.strings.sold_out);
    }
    function renderRows() {
      if (!rowsHost) return;
      if (qty <= 1) { rowsWrap.hidden = true; return; }
      rowsWrap.hidden = false;
      const existing = $$('[data-bundle-row-item]', rowsHost);
      const sel = selectedOptions();
      for (let i = existing.length; i < qty; i++) {
        const frag = rowTpl.content.cloneNode(true);
        const row = frag.querySelector('[data-bundle-row-item]');
        $('[data-row-index]', row).textContent = i + 1;
        $$('select[data-row-option]', row).forEach((s2, k) => { s2.value = sel[k] || s2.value; });
        if (i === 0) row.dataset.mirror = '1';
        rowsHost.appendChild(frag);
      }
      $$('[data-bundle-row-item]', rowsHost).forEach((row, i) => { if (i >= qty) row.remove(); else syncRowStatus(row); });
    }
    function bundleItems() {
      if (qty <= 1 || !rowsHost) return null;
      const map = new Map();
      for (const row of $$('[data-bundle-row-item]', rowsHost)) {
        const v = rowVariant(row); if (!v || !v.available) return { error: window.PoppyLoco.strings.bundle_unavailable };
        map.set(v.id, (map.get(v.id) || 0) + 1);
      }
      return { items: Array.from(map, ([id, quantity]) => ({ id, quantity })) };
    }
    function bundleTotal(price) {
      if (qty <= 1 || !rowsHost) return Math.round(price * qty * (1 - pct / 100));
      let sum = 0; $$('[data-bundle-row-item]', rowsHost).forEach((row) => { const v = rowVariant(row); sum += v ? v.price : price; });
      return Math.round(sum * (1 - pct / 100));
    }
    if (rowsHost) rowsHost.addEventListener('change', (e) => { const row = e.target.closest('[data-bundle-row-item]'); if (row) { delete row.dataset.mirror; syncRowStatus(row); render(); } });

    function updateAvailability() {
      const sel = selectedOptions();
      $$('.variant', section).forEach((f, idx) => {
        $$('input', f).forEach((inp) => {
          const test = sel.slice(); test[idx] = inp.value;
          const match = variants.find((v) => v.options.every((o, i) => i === idx || !test[i] ? true : o === test[i]) && v.options[idx] === inp.value);
          const available = match ? variants.some((v) => v.options.every((o, i) => o === test[i]) && v.available) : false;
          inp.nextElementSibling.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function render() {
      const price = current ? current.price : 0;
      const compare = current && current.compare_at_price > price ? current.compare_at_price : 0;
      $$('[data-price]').forEach((el) => (el.textContent = money(price)));
      $$('[data-compare]').forEach((el) => { el.textContent = compare ? money(compare) : ''; el.hidden = !compare; });
      const pill = $('[data-discount-pill]', section);
      if (pill) { pill.hidden = !compare; if (compare) $('[data-discount]', pill).textContent = Math.floor(((compare - price) / compare) * 100); }
      $$('.variant', section).forEach((f) => { const v = $('input:checked', f)?.value; const t = $('[data-selected-value]', f); if (t) t.textContent = v || ''; });
      const sv = $('[data-stock-variant]', section); if (sv && current) sv.textContent = current.title;
      // bundle
      if (bundle) {
        $$('[data-tier]', bundle).forEach((t) => {
          const q = Number(t.dataset.qty), p = Number(t.dataset.pct) || 0;
          const total = Math.round(price * q * (1 - p / 100));
          const cmp = (compare || price) * q;
          $('[data-tier-price]', t).textContent = money(total);
          const s = $('[data-tier-compare]', t); s.textContent = cmp > total ? money(cmp) : ''; s.hidden = cmp <= total;
        });
      }
      renderRows();
      if (rowsHost) { const sel = selectedOptions(); $$('[data-bundle-row-item][data-mirror]', rowsHost).forEach((row) => { $$('select[data-row-option]', row).forEach((s2, k) => { s2.value = sel[k] || s2.value; }); syncRowStatus(row); }); }
      const total = bundleTotal(price);
      const ap = $('[data-atc-price]', section); if (ap) ap.textContent = money(total);
      const available = current && current.available;
      atc.disabled = !available;
      $('[data-atc-text]', section).textContent = available ? window.PoppyLoco.strings.add.toUpperCase() : (current ? window.PoppyLoco.strings.sold_out : window.PoppyLoco.strings.unavailable);
      if (current) {
        idInput.value = current.id;
        const url = new URL(window.location); url.searchParams.set('variant', current.id); history.replaceState({}, '', url);
        if (current.featured_media) goToMedia(current.featured_media.id);
      }
      qtyInput.value = qty;
      updateAvailability();
    }

    section.addEventListener('change', (e) => {
      if (e.target.matches('.variant__input')) {
        const sel = selectedOptions();
        current = variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
        render();
      }
      if (e.target.closest('[data-tier]')) {
        const t = e.target.closest('[data-tier]');
        $$('[data-tier]', bundle).forEach((x) => x.classList.remove('is-selected'));
        t.classList.add('is-selected'); qty = Number(t.dataset.qty); pct = Number(t.dataset.pct) || 0; render();
      }
    });

    if (bundle) { const sel = $('[data-tier].is-selected', bundle); if (sel) { qty = Number(sel.dataset.qty); pct = Number(sel.dataset.pct) || 0; } }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current || !current.available) return;
      const errBox = $('[data-atc-error]', section);
      const showErr = (m) => { if (errBox) { errBox.textContent = m; errBox.hidden = false; } else alert(m); };
      if (errBox) errBox.hidden = true;
      const b = bundleItems();
      if (b && b.error) { showErr(b.error); return; }
      atc.classList.add('is-loading'); atc.disabled = true;
      try { await addToCart(current.id, qty, b && b.items); }
      catch (err) { showErr((err.message || '').replace(/^(Le produit|The product|El producto) [«"“].*?[»"”] /, window.PoppyLoco.strings.this_item) || window.PoppyLoco.strings.error_generic); }
      finally { atc.classList.remove('is-loading'); atc.disabled = false; }
    });

    /* Gallery */
    const track = $('[data-gallery-track]', section);
    const slides = $$('.gallery__slide', section);
    const thumbs = $$('[data-thumb]', section);
    const dots = $$('[data-gallery-dots] span', section);
    let idx = 0;
    function goTo(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${idx * 100}%)`;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === idx));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === idx));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === idx));
      const t = thumbs[idx]; if (t) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    function goToMedia(mediaId) { const s = slides.findIndex((x) => x.dataset.mediaId === String(mediaId)); if (s > -1) goTo(s); }
    $('[data-gallery-prev]', section)?.addEventListener('click', () => goTo(idx - 1));
    $('[data-gallery-next]', section)?.addEventListener('click', () => goTo(idx + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.index))));
    let sx = 0;
    track.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) goTo(dx < 0 ? idx + 1 : idx - 1); });

    /* Live viewers */
    const live = $('[data-live-count]', section);
    if (live) {
      const min = Number(live.dataset.min), max = Number(live.dataset.max);
      let n = Math.floor(min + Math.random() * (max - min)); live.textContent = n;
      setInterval(() => { n = Math.max(min, Math.min(max, n + (Math.random() > 0.5 ? 1 : -1))); live.textContent = n; }, 4000 + Math.random() * 3000);
    }

    /* Countdown (persisted per session) */
    const cd = $('[data-countdown]', section);
    if (cd) {
      const key = 'pl_cd_end'; const mins = Number(cd.dataset.minutes) || 15;
      let end = Number(sessionStorage.getItem(key)); if (!end || end < Date.now()) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, end); }
      const disp = $('[data-countdown-display]', cd);
      const tick = () => { let r = Math.max(0, end - Date.now()); if (r === 0) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, end); r = mins * 60000; } const m = Math.floor(r / 60000), s = Math.floor((r % 60000) / 1000); disp.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`; };
      tick(); setInterval(tick, 1000);
    }

    /* Stock */
    const stock = $('[data-stock]', section);
    if (stock) {
      const min = Number(stock.dataset.min), max = Number(stock.dataset.max);
      const n = Math.floor(min + Math.random() * (max - min + 1));
      $('[data-stock-count]', stock).textContent = n;
      $('[data-stock-bar]', stock).style.width = Math.max(8, Math.min(40, n * 3)) + '%';
    }

    /* Delivery dates */
    const d = $('[data-delivery]', section);
    if (d) {
      const addDays = (days) => { const dt = new Date(); dt.setDate(dt.getDate() + days); return dt; };
      const loc = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' }[window.PoppyLoco.locale] || 'fr-FR';
      const f = (dt) => dt.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'long' });
      $('[data-delivery-from]', d).textContent = f(addDays(Number(d.dataset.min)));
      $('[data-delivery-to]', d).textContent = f(addDays(Number(d.dataset.max)));
    }

    /* Sticky ATC */
    const sticky = $('[data-sticky-atc]');
    if (sticky) {
      const obs = new IntersectionObserver(([en]) => { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); sticky.setAttribute('aria-hidden', en.isIntersecting); }, { threshold: 0 });
      obs.observe(atc);
      $('[data-sticky-atc-btn]', sticky).addEventListener('click', () => { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    render();
  }

  /* ---------- Reviews "voir plus" ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-reviews-more]'); if (!b) return;
    $$('.review.is-hidden').slice(0, 6).forEach((r) => r.classList.remove('is-hidden'));
    if (!$('.review.is-hidden')) b.remove();
  });
})();
